 
// renew 작업
import renewMain from '@/renew/layouts/main/Main.vue'
import renewlogin from '@/viewsRenew/login/index.vue'
import renewMember from '@/viewsRenew/member/index.vue'
import renewMemberDetail from '@/viewsRenew/member/detail.vue'
import registerMember from '@/viewsRenew/member/registration.vue'
import registerMemberExcel from '@/viewsRenew/member/registration_excel.vue'

import artist from '@/viewsRenew/artist/index.vue'
import artistDetail from '@/viewsRenew/artist/detail.vue'
import artistRegister from '@/viewsRenew/artist/registration.vue'

import album from '@/viewsRenew/album/index.vue'
import albumDetail from '@/viewsRenew/album/detail.vue'
import albumRegister from '@/viewsRenew/album/registration.vue'
import albumRegisterTemp from '@/viewsRenew/album/registration_temp.vue'
import albumRegisterExcel from '@/viewsRenew/album/registration_excel.vue'
import mims from '@/viewsRenew/album/mims.vue'
import massive from '@/viewsRenew/album/registration_massive.vue'


import calendar from '@/viewsRenew/calendar/index.vue'
import calendarDetail from '@/viewsRenew/calendar/detail.vue'
import calendarWrap from '@/viewsRenew/calendar/wrap.vue'
import track from '@/viewsRenew/track/index.vue'
import genre from '@/viewsRenew/genre/index.vue'

//지급처리내역
import transaction from '@/viewsRenew/transaction/index.vue'
import withdrawal from '@/viewsRenew/withdrawal/index.vue'

//정산내역
import upload from '@/viewsRenew/data/upload/index.vue'
import uploadDetail from '@/viewsRenew/data/upload/detail.vue'

import uploadExcel from '@/viewsRenew/data/upload/registration_excel.vue'
import codeTrack from '@/viewsRenew/data/upload/code_track.vue'
import codeAlbum from '@/viewsRenew/data/upload/code_album.vue'
import nameTrack from '@/viewsRenew/data/upload/name_track.vue'
import nameAlbum from '@/viewsRenew/data/upload/name_album.vue'


import exchange from '@/viewsRenew/data/exchange/index.vue'
import openLog from '@/viewsRenew/data/openLog/index.vue'
import settlement from '@/viewsRenew/data/settlement/index.vue'

import musicstore from '@/viewsRenew/musicStore/index.vue'

import aggregator from '@/viewsRenew/aggregator/index.vue'
import aggregatorDetail from '@/viewsRenew/aggregator/detail.vue'
import aggregatorRegister from '@/viewsRenew/aggregator/registration.vue'


import taxinvoice from '@/viewsRenew/taxinvoice/index.vue'
import taxinvoiceDetail from '@/viewsRenew/taxinvoice/detail.vue'
import taxinvoiceRegister from '@/viewsRenew/taxinvoice/registration.vue'

import transfer from '@/viewsRenew/transfer/index.vue'
import transferDetail from '@/viewsRenew/transfer/detail.vue'
import transferRegister from '@/viewsRenew/transfer/registration.vue'


import advancepayment from '@/viewsRenew/advancepayment/index.vue'
import advancepaymentDetail from '@/viewsRenew/advancepayment/detail.vue'
import advancepaymentRegister from '@/viewsRenew/advancepayment/registration.vue'

import ddexJob from '@/viewsRenew/ddex/job/index.vue'
import ddexDetail from '@/viewsRenew/ddex/job/detail.vue'
import ddexRegister from '@/viewsRenew/ddex/job/registration.vue'
import albumDeliveryTracker from '@/viewsRenew/albumDeliveryTracker/index.vue'

import ddexStore from '@/viewsRenew/ddex/store/index.vue'
import blackListLabel from '@/viewsRenew/ddex/blackList/label_index.vue'
import blackListGenre from '@/viewsRenew/ddex/blackList/genre_index.vue'
import blackListArtist from '@/viewsRenew/ddex/blackList/artist_index.vue'


import faq from '@/viewsRenew/support/faq.vue'
import faqRegistration from '@/viewsRenew/support/faqRegistration.vue'
import faqDetail from '@/viewsRenew/support/faqDetail.vue'
import notice from '@/viewsRenew/support/notice.vue'
import noticeRegistration from '@/viewsRenew/support/noticeRegistration.vue'
import noticeDetail from '@/viewsRenew/support/noticeDetail.vue'
import inquiry from '@/viewsRenew/support/inquiry.vue'
import inquiryDetail from '@/viewsRenew/support/inquiryDetail.vue'

import codeGenerationExport from '@/viewsRenew/album/codeGenerationExport/index.vue'
import codeGenerationPrefixStatus from '@/viewsRenew/album/codeGenerationExport/prefixStatus/index.vue'
import isrcPrefixStatus from '@/viewsRenew/album/isrcPrefixStatus/index.vue'
import royaltyReporting from '@/viewsRenew/royaltyReporting/index.vue'
import exportPresetList from '@/viewsRenew/exportPreset/index.vue'
import exportPresetForm from '@/viewsRenew/exportPreset/form.vue'

import test from '@/viewsRenew/test.vue'

// YouTube Content ID
import youtubeCidSearch from '@/viewsRenew/youtubeCid/AssetSearch.vue'
import youtubeCidAssetDetail from '@/viewsRenew/youtubeCid/AssetDetail.vue'
import youtubeCidClaimDetail from '@/viewsRenew/youtubeCid/ClaimDetail.vue'
import youtubeCidVideoClaims from '@/viewsRenew/youtubeCid/VideoClaimsList.vue'
import youtubeCidWhitelists from '@/viewsRenew/youtubeCid/WhitelistsList.vue'

const renew = {
  path: '/renew',
  component: renewMain,
  //redirect: '/renew',
  name: "renew",
  children: [
    {
      path: '/member',
      name: '사용자 목록',
      components: {
        default: renewMember
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/member/detail/:id',
      name: '사용자 상세',
      components: {
        default: renewMemberDetail
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/member/registration',
      name: '사용자 등록',
      components: {
        default: registerMember
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/member/registrationexcel',
      name: '사용자 엑셀 등록',
      components: {
        default: registerMemberExcel
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/artist',
      name: '아티스트 목록',
      components: {
        default: artist
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/artist/registration',
      name: '아티스트 등록',
      components: {
        default: artistRegister
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/artist/detail/:id',
      name: '아티스트 상세',
      components: {
        default: artistDetail
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/album',
      name: '앨범 목록',
      components: {
        default: album
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/album/detail/:id',
      name: '앨범 상세',
      components: {
        default: albumDetail
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/code-generation-export',
      name: 'GS1 바코드 관리 (UPC/EAN)',
      components: {
        default: codeGenerationExport
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/code-generation/prefix-status',
      name: 'GS1 바코드 프리픽스 현황',
      components: {
        default: codeGenerationPrefixStatus
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/code-generation/isrc-prefix-status',
      name: 'ISRC 프리픽스 현황',
      components: {
        default: isrcPrefixStatus
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/royalty-reporting',
      name: '정산 공개일 관리',
      components: {
        default: royaltyReporting
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/album/registration',
      name: '앨범 등록',
      components: {
        default: albumRegister
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/album/registrationtemp',
      name: '임시앨범 등록',
      components: {
        default: albumRegisterTemp
      },
      meta: { requiresAuth: true }
    },
    
    {
      path: '/album/registrationexcel',
      name: '앨범 엑셀 등록',
      components: {
        default: albumRegisterExcel
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/album/mims',
      name: 'mims',
      components: {
        default: mims
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/album/registration/massive',
      name: '대량이관 등록',
      components: {
        default: massive,
      },
      meta: { requiresAuth: true }
    },

    {
      path: '/calendar2',
      name: '캘린더',
      components: {
        default: calendar
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/calendar/detail/:id',
      name: '캘린더',
      components: {
        default: calendarDetail
      },
      meta: { requiresAuth: true }
    },
    
    {
      path: '/calendar',
      name: '캘린더',
      components: {
        default: calendarWrap
      },
      meta: { requiresAuth: true }
    },
    
    {
      path: '/track',
      name: '트랙 목록',
      components: {
        default: track
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/genre',
      name: '장르 목록',
      components: {
        default: genre
      },
      meta: { requiresAuth: true }
    },
    
    {
      path: '/withdrawal',
      name: '출금신청내역',
      components: {
        default: withdrawal
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/transaction',
      name: '거래내역',
      components: {
        default: transaction
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/dataUploadExcel',
      name: '데이터 업로드',
      components: {
        default: uploadExcel
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/dataUpload',
      name: '데이터 업로드/검수',
      components: {
        default: upload
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/dataUpload/detail/:id',
      name: '데이터 업로드/검수',
      components: {
        default: uploadDetail
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/dataUpload/detail/:id/codetrack',
      name: '트랙코드 재매칭',
      components: {
        default: codeTrack
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/dataUpload/detail/:id/codealbum',
      name: '앨범코드 재매칭',
      components: {
        default: codeAlbum
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/dataUpload/detail/:id/nametrack',
      name: '트랙명 재매칭',
      components: {
        default: nameTrack
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/dataUpload/detail/:id/namealbum',
      name: '앨범명 재매칭',
      components: {
        default: nameAlbum
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/dataExchange',
      name: '환전 처리',
      components: {
        default: exchange
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/dataOpen',
      name: '공개 처리',
      components: {
        default: openLog
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/settlement',
      name: '정산내역',
      components: {
        default: settlement
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/aggregator',
      name: '계약사목록',
      components: {
        default: aggregator
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/aggregator/detail/:id',
      name: '계약사 상세',
      components: {
        default: aggregatorDetail
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/aggregator/registration',
      name: '계약사 등록',
      components: {
        default: aggregatorRegister
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/taxinvoice',
      name: '정산세계발행',
      components: {
        default: taxinvoice
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/taxinvoice/detail/:id',
      name: '정산세계발행 상세',
      components: {
        default: taxinvoiceDetail
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/taxinvoice/registration',
      name: '정산세계발행 등록',
      components: {
        default: taxinvoiceRegister
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/musicstore',
      name: '뮤직스토어 목록',
      components: {
        default: musicstore
      },
      meta: { requiresAuth: true }
    },

    {
      path: '/transfer',
      name: '내부이관 목록',
      components: {
        default: transfer
      },
      meta: { requiresAuth: true }
    },

    {
      path: '/transfer/detail/:id',
      name: '내부이관 상세',
      components: {
        default: transferDetail
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/transfer/registration',
      name: '내부이관 등록',
      components: {
        default: transferRegister
      },
      meta: { requiresAuth: true }
    },
    
    {
      path: '/advancepayment',
      name: '선급금계약 목록',
      components: {
        default: advancepayment
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/advancepayment/detail/:id',
      name: '선급금계약 상세',
      components: {
        default: advancepaymentDetail
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/advancepayment/registration',
      name: '선급금계약 등록',
      components: {
        default: advancepaymentRegister
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/ddex/job',
      name: 'Delivery Job목록',
      components: {
        default: ddexJob
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/album-delivery-tracker',
      name: '해외 앨범 유통 현황',
      components: {
        default: albumDeliveryTracker
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/ddex/job/detail/:id',
      name: 'Delivery Job상세',
      components: {
        default: ddexDetail
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/ddex/job/registration',
      name: 'Delivery Job등록',
      components: {
        default: ddexRegister
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/ddex/store',
      name: 'DDEX 계약사 목록',
      components: {
        default: ddexStore
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/ddex/store/registration',
      name: 'DDEX 계약사 목록',
      components: {
        default: ddexStore
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/ddex/blacklabel',
      name: 'Black List 기획사',
      components: {
        default: blackListLabel
      },
      meta: { requiresAuth: true }
    },    
    {
      path: '/ddex/blackgenre',
      name: 'Black List 장르',
      components: {
        default: blackListGenre
      },
      meta: { requiresAuth: true }
    },  
    {
      path: '/ddex/blackartist',
      name: 'Black List 아티스트',
      components: {
        default: blackListArtist
      },
      meta: { requiresAuth: true }
    },  
    {
      path: '/support/faq',
      name: 'FAQ',
      components: {
        default: faq
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/support/faq/registration',
      name: 'FAQ 등록',
      components: {
        default: faqRegistration
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/support/faq/:id',
      name: 'FAQ 상세',
      components: {
        default: faqDetail
      },
      meta: { requiresAuth: true }
    },
    
    {
      path: '/support/notice',
      name: '공지사항',
      components: {
        default: notice
      },
      meta: { requiresAuth: true }
    },  
     {
      path: '/support/notice/registration',
      name: '공지사항 등록',
      components: {
        default: noticeRegistration
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/support/notice/:id',
      name: '공지사항 상세',
      components: {
        default: noticeDetail
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/support/inquiry',
      name: '1:1 문의',
      components: {
        default: inquiry
      },
      meta: { requiresAuth: true }
    },
 
    {
      path: '/support/inquiry/:id',
      name: '1:1 문의 상세',
      components: {
        default: inquiryDetail
      },
      meta: { requiresAuth: true }
    },
    {
      path: '/export-preset',
      name: 'DSP Group 목록',
      components: { default: exportPresetList },
      meta: { requiresAuth: true }
    },
    {
      path: '/export-preset/registration',
      name: 'DSP Group 등록',
      components: { default: exportPresetForm },
      meta: { requiresAuth: true }
    },
    {
      path: '/export-preset/edit/:id',
      name: 'DSP Group 수정',
      components: { default: exportPresetForm },
      meta: { requiresAuth: true }
    },
    {
      path: '/youtube-cid',
      name: 'YouTube Content ID',
      components: { default: youtubeCidSearch },
      meta: { requiresAuth: true }
    },
    {
      path: '/youtube-cid/asset/:id',
      name: 'YouTube Content ID — 저작물',
      components: { default: youtubeCidAssetDetail },
      meta: { requiresAuth: true }
    },
    {
      path: '/youtube-cid/claim/:id',
      name: 'YouTube Content ID — 소유권 주장',
      components: { default: youtubeCidClaimDetail },
      meta: { requiresAuth: true }
    },
    {
      path: '/youtube-cid/video/:id',
      name: 'YouTube Content ID — 동영상 소유권 주장',
      components: { default: youtubeCidVideoClaims },
      meta: { requiresAuth: true }
    },
    {
      path: '/youtube-cid/whitelists',
      name: 'YouTube Content ID — 허용 목록',
      components: { default: youtubeCidWhitelists },
      meta: { requiresAuth: true }
    },
    {
      path: '/test',
      name: '테스트테스트',
      components: {
        default: test
      },
      meta: { requiresAuth: false }
    }
  ]
}

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: { path: '/member' },
  },
  {
    path: '/login',
    component: renewlogin,
    children: [
      {
        path: '*',
        name: 'loin',
        components: { default: renewlogin },
      },
    ],
  },
  
  renew,
  // CirculationManagementRoutes,
  // BalancingAccountRoutes,
  // Members,
  // login,
  // Payment,
  // {
  //   path: '*',
  //   component: AuthLayout,
  //   children: [
  //     {
  //       path: '*',
  //       name: '404 NotFound',
  //       components: { default: NotFoundPage },
  //     },
  //   ],
  // },
]

export default routes
